import PoliceCentralUserInfo from "@/pages/Users/sections/PoliceCentralUserInfo";

const StaffPoliceCentralUserInfo = () => {
    return(
        <>
        <PoliceCentralUserInfo />
        </>
    )
}
export default StaffPoliceCentralUserInfo;